'use client'

import CustomerQuote from '@/components/CustomerQuote'

const LogixboardCustomerQuote1 = () => (
    <CustomerQuote
        sx={{
            height: {
                xs: `792px`,
                sm: `792px`,
                md: `480px`,
                lg: `480px`,
                xl: `480px`,
            },
        }}
        light={false}
        backgroundImageSrc={'/images/logixboard-case-study/customer-quote-1-desktop.png'}
        mobileBackgroundImageSrc={'/images/ets-maps/ets-explorer-mobile-1.png'}
        text={
            <>
                “The technical collaboration was probably the best we’ve ever had with a vendor. I
                remember [the engineers] saying they’ve never worked with a vendor that’s this easy
                to work with!”
            </>
        }
        avatar={{
            title: 'Jarred Wolff',
            subtitle: 'Technical Product Manager at Logixboard',
            imageSrc: '/images/logixboard-case-study/jarred-wolff.png',
        }}
        reversedOnMobile
    />
)

export default LogixboardCustomerQuote1
